import Swal from 'sweetalert2'

// Default config
const defaultConfig = {
  confirmButtonColor: '#3085d6',
  cancelButtonColor: '#d33',
  confirmButtonText: 'OK',
  allowOutsideClick: false,
}

// Success alert
export const showSuccess = (title, text = '', timer = 1500) => {
  return Swal.fire({
    ...defaultConfig,
    icon: 'success',
    title,
    text,
    timer,
    showConfirmButton: timer === null,
  })
}

// Error alert
export const showError = (title, text = '') => {
  return Swal.fire({
    ...defaultConfig,
    icon: 'error',
    title,
    text,
  })
}

// Warning alert
export const showWarning = (title, text = '') => {
  return Swal.fire({
    ...defaultConfig,
    icon: 'warning',
    title,
    text,
  })
}

// Info alert
export const showInfo = (title, text = '') => {
  return Swal.fire({
    ...defaultConfig,
    icon: 'info',
    title,
    text,
  })
}

// Confirm dialog
export const showConfirm = async (title, text, confirmText = 'Ya', cancelText = 'Tidak') => {
  const result = await Swal.fire({
    ...defaultConfig,
    icon: 'question',
    title,
    text,
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
  })
  return result.isConfirmed
}

// Toast notification
export const showToast = (title, icon = 'success', timer = 3000) => {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })

  return Toast.fire({
    icon,
    title
  })
}

// Simple alert (replacement for native alert)
export const showAlert = (title, text = '', icon = 'info') => {
  return Swal.fire({
    ...defaultConfig,
    icon,
    title,
    text,
  })
}
